// extracted by mini-css-extract-plugin
export var advantages = "advantages-module--advantages--1dbf0";
export var sub = "advantages-module--sub--c6b70";